import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxDragPreviewMultipleComponent } from './rx-drag-preview-multiple/rx-drag-preview-multiple.component';
import { RxIconModule } from '@nrwl/rx-icon';

@NgModule({
  imports: [CommonModule, RxIconModule, RxDragPreviewMultipleComponent],
  exports: [RxDragPreviewMultipleComponent],
})
export class RxDragPreviewModule {}
